import React, { useState, useEffect } from 'react';
import { Modal, Form, Toast, Input, Button, Swiper } from 'antd-mobile';
import { RightOutline } from 'antd-mobile-icons';
import MobileNav from '../../../compontents/mobileNav';
import axios from 'axios';
import './index.less'

const IndexPage = () => {

  const getOld = new Map([
    [1, '全新'],
    [2, '99新'],
    [3, '95新'],
    [4, '9成新'],
    [5, '8成新'],
    [6, '7成新'],
  ]);

  const [cateClickId, setCateClickId] = useState('link1');
  const [itemWidth, setItemWidth] = useState(0)
  const [productData2, setProductData2] = useState([])
  const [productData3, setProductData3] = useState([])
  const [productData4, setProductData4] = useState([])
  const [productData5, setProductData5] = useState([])
  const [productData6, setProductData6] = useState([])

  useEffect(() => {
    const itemW = document.getElementById('cate1')
    setItemWidth(itemW.offsetWidth)
    onFinish(2)
    onFinish(3)
    onFinish(4)
    onFinish(5)
    onFinish(6)
  }, [])

  const submitForm = (data) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/product/querySitProductList',
    responseType: 'json',
    data
  })

  const onFinish = (values) => {
    submitForm({
      type: values
    }).then(res => {
      if (values == 1) {
        // setProductData(res.data.data)
      } else if (values == 2) {
        setProductData2(res.data.data)
      } else if (values == 3) {
        setProductData3(res.data.data)
      } else if (values == 4) {
        setProductData4(res.data.data)
      } else if (values == 5) {
        setProductData5(res.data.data)
      } else if (values == 6) {
        setProductData6(res.data.data)
      }
    });
  };

  const headerChangePages = (num) => {
    window.location.href = `${window.location.origin}${window.location.pathname}?flag=${num}`
  }

  const toAlipay = (type, type1, ids) => {
    // console.log(type,type1,ids,'三个参数')
    // return
    if (type == 1) {
      if (type1 == 1) {
        window.location.href = `alipays://platformapi/startapp?appId=${2019011162880259}&page=pages/home/index`
      } else {
        window.location.href = `alipays://platformapi/startapp?appId=${2019011162880259}&page=pages/productDetail/index&query=${encodeURIComponent(`itemId=${ids}`)}`
      }
    } else {
      if (type1 == 1) {
        window.location.href = `alipays://platformapi/startapp?appId=${2021004161622584}&page=pages/home/index`

      } else {
        window.location.href = `alipays://platformapi/startapp?appId=${2021004161622584}&page=pages/productDetail/index&query=${encodeURIComponent(`itemId=${ids}`)}`
      }
    }
  }

  const showModalFun = (type, ids) => {
    Modal.show({
      content: (
        <div className='modalContentLinkContent' style={{ textAlign: 'center', background: '#fff' }} >
          <div className='modalContentLink_title' style={{
            fontFamily: 'PingFangSC, PingFang SC',
            fontWeight: 500,
            fontSize: '2.25rem',
            color: '#333',
            lineHeight: '2.5rem',
            fontStyle: 'normal',
          }} >
            请选择租赁方式
          </div>
          <div className='modalContentLink_box' style={{ display: 'flex', justifyContent: 'space-around', marginTop: '3rem' }} >
            <div className='modalContentLink_box_left' style={{
              width: '13.63rem',
              height: '4.5rem',
              borderRadius: '1rem',
              border: '0.06rem solid #cccccc',
              fontFamily: 'PingFangSC, PingFang SC',
              fontWeight: 400,
              fontSize: '1.75rem',
              color: '#333',
              lineHeight: '2.25rem',
              textAlign: 'center',
              lineHeight: '4.5rem',
              fontStyle: 'normal',
            }} onClick={() => toAlipay(1, type, ids)}  >个人租赁</div>
            <div className='modalContentLink_box_right' style={{
              width: '13.63rem',
              height: '4.5rem',
              borderRadius: '1rem',
              background: '#ED0000',
              fontFamily: 'PingFangSC, PingFang SC',
              fontWeight: 400,
              fontSize: '1.75rem',
              color: '#fff',
              lineHeight: '2.25rem',
              textAlign: 'center',
              lineHeight: '4.5rem',
              fontStyle: 'normal',
            }} onClick={() => toAlipay(2, type, ids)}>企业租赁</div>
          </div>
        </div>
      ),
      closeOnMaskClick: true,
      className: 'modalContentLink',
      bodyStyle: {
        background: '#fff'
      },
      disableBodyScroll: true
    })
  }

  const scrollToView = (index) => {
    let anchorElement
    anchorElement = document.getElementById(`${index}`);
    console.log(anchorElement, 'anchorElement')
    if (anchorElement) {
      // anchorElement.scrollIntoView({
      //   block: 'start',
      //   behavior: 'smooth',
      // });
      window.scrollTo({
        top: anchorElement.offsetTop - 50, // 添加偏移
        behavior: "smooth"
      });
    }
  }

  const changeCate = (id) => {
    console.log(id, '选中')
    setCateClickId(id)
    scrollToView(id)
  }

  const cateNavList = [
    {
      name: '行政办公',
      linkId: 'link1'
    },
    {
      name: '打印设备',
      linkId: 'link2'
    },
    {
      name: '电商直播',
      linkId: 'link3'
    },
    {
      name: '设计剪辑',
      linkId: 'link4'
    },
    {
      name: '游戏电竞',
      linkId: 'link5'
    },
  ]

  const productList = [
    {
      linkId: 'link1',
      icon: 'https://oss.huizustore.com/d41873d1e4e04ba684fef8321cbe9532.png',
      tip: '高效办公轻松租',
      productData: productData2.slice(0, 4),
    },
    {
      linkId: 'link2',
      icon: 'https://oss.huizustore.com/6a068cbfc7d64049996f1f3a259de36b.png',
      tip: '打印设备随时租',
      productData: productData3.slice(0, 4),
    },
    {
      linkId: 'link3',
      icon: 'https://oss.huizustore.com/14a91042037946aaaafb611974d0266b.png',
      tip: '直播装备随心租',
      productData: productData4.slice(0, 4),
    },
    {
      linkId: 'link4',
      icon: 'https://oss.huizustore.com/f55f03dc93a1450d8527b4d0cf66bf25.png',
      tip: '设计设备便捷租',
      productData: productData5.slice(0, 4),
    },
    {
      linkId: 'link5',
      icon: 'https://oss.huizustore.com/131507f1346f409b9e127fe458f1745b.png',
      tip: '电竞装备畅快租',
      productData: productData6.slice(0, 4),
    },
  ]

  const submitForm1 = (data) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/user/submitUserConsultInfo',
    responseType: 'json',
    data
  })

  const onFinishForm = (values) => {
    submitForm1({
      ...values,
      consultType: 1,
      consultSource: 1,
    }).then(res => {
      if (res?.data?.code === 1) {
        Modal.clear()
        Toast.show({
          icon: 'success',
          content: res.data.msg,
        })
      } else {
        Toast.show({
          icon: 'fail',
          content: res.data.msg,
        })
      }
    });
  };

  const showModal = () => {
    Modal.show({
      content: (
        <div className="mobile-business-modal-content">
          <strong>立即预约</strong>
          <div className="close" onClick={(e) => {
            Modal.clear()
          }}></div>
          <Form layout="horizontal" mode='card' onFinish={onFinishForm} footer={<Button block type="submit" color="danger" style={{ width: '50%', margin: '0 auto' }}>提交</Button>}>
            <div className="form_line">
              <span>姓<div style={{ opacity: '0', display: 'inline' }}>占位</div>名：</span>
              <Form.Item name="contactName" rules={[{ required: true, message: '请输入姓名' }]}>
                <Input placeholder='请输入姓名' />
              </Form.Item>
            </div>
            <div className="form_line">
              <span>企业名称：</span>
              <Form.Item name="enterpriseName" rules={[{ required: true, message: '请输入企业名称' }]}>
                <Input placeholder='请输入企业名称' />
              </Form.Item>
            </div>
            <div className="form_line">
              <span>手机号码：</span>
              <Form.Item name="telephone" rules={[{ required: true, message: '请输入手机号码' }]}>
                <Input placeholder='请输入手机号码' />
              </Form.Item>
            </div>
            <div className="form_line">
              <span>意向类型：</span>
              <Form.Item name="categories">
                <Input placeholder='请输入意向类型' />
              </Form.Item>
            </div>
          </Form>
        </div>
      ),
      closeOnMaskClick: true,
      className: "mobile-business-modal"
    })
  }

  return (
    <div className='IndexPageCss' >
      <MobileNav />
      <Swiper
        indicatorProps={{ style: { "--active-dot-color": '#ED0000', '--active-dot-size': '3px', '--active-dot-border-radius': '50%' } }}
        allowTouchMove
        autoplay
        loop
        autoplayInterval={5000}
        className="IndexPageCss_swiper"
      >
        <Swiper.Item>
          <div className="IndexPageCss_swiper_con1" onClick={() => headerChangePages(9)} >

          </div>
        </Swiper.Item>
        <Swiper.Item>
          <div className="IndexPageCss_swiper_con2" onClick={() => showModal()} >

          </div>
        </Swiper.Item>
      </Swiper>
      <div className='IndexPageCss_topCon' >
        <div className='IndexPageCss_topCon_item' >
          <div className='item_top1' >

          </div>
          <div className='item_center' >
            免押租赁
          </div>
          <div className='item_bottom' >
            0押金信用免押
          </div>
        </div>
        <div className='IndexPageCss_topCon_item' >
          <div className='item_top2' >

          </div>
          <div className='item_center' >
            全程无忧
          </div>
          <div className='item_bottom' >
            设备故障 快速响应
          </div>
        </div>
        <div className='IndexPageCss_topCon_item' >
          <div className='item_top3' >

          </div>
          <div className='item_center' >
            专人安装
          </div>
          <div className='item_bottom' >
            专业团队 省心省力
          </div>
        </div>
      </div>
      <div className='IndexPageCss_cateNav' >
        {cateNavList.map(item => (
          <div id='cate1' onClick={() => changeCate(item.linkId)} className={cateClickId === item.linkId ? 'IndexPageCss_cateNav_itemClick' : 'IndexPageCss_cateNav_item'}  >
            {item.name}
            {cateClickId === item.linkId && (
              <div className='IndexPageCss_cateNav_itemClick_line' style={{ left: (itemWidth - 52) / 2 }} ></div>
            )}
          </div>
        ))}

      </div>
      <div className='IndexPageCss_product' >
        {productList.map(item => (
          <div className='IndexPageCss_product_productBox' id={item.linkId} >
            <div className='productBox_top'  >
              <div style={{ display: 'flex' }} >
                <div className='productBox_top_icon' style={{ backgroundImage: `url(${item.icon})` }} >
                </div>
                <div className='productBox_top_tip' >
                  {item.tip}
                </div>
              </div>
              <div style={{ display: 'flex' }} onClick={() => showModalFun(1)} >
                <div className='productBox_top_btn' >
                  查看更多
                </div>
                <RightOutline className='productBox_top_right' />
                {/* <div className='productBox_top_right' >

                </div> */}
              </div>

            </div>
            <div className='productBox_list' >
              {item.productData && item.productData.length > 0 && item.productData.map(_item => (
                <div className='productBox_list_item' onClick={() => showModalFun(2, _item?.productInfo?.productId)} >
                  <div className='productItem_pic' style={{ backgroundImage: `url(${_item.productInfo.images})` }} >

                  </div>
                  <div className='productItem_titleBox' >
                    <div className='productItem_titleBox_oldNew' >{getOld.get(_item.productInfo.oldNewDegree)}</div>
                    <div className='productItem_titleBox_title' >{_item.productInfo.productName || '-'}</div>
                  </div>
                  <div className='productItem_sku' >
                    {_item.productInfo.skuTitle}
                  </div>
                  <div className='productItem_tagBox' >
                    {_item.productServiceLabs.map(item => (
                      <div className='productItem_tagBox_tagItem' >
                        {item?.serviceLabName}
                      </div>
                    ))}
                  </div>
                  <div className='productItem_bottom' >
                    <div className='productItem_bottom_price' >
                      <span>¥</span>
                      <span className='productItem_bottom_price_big' >{_item.productInfo.rent}</span>
                      <span>/天</span>
                    </div>
                    {_item?.productInfo?.unionProductStatus && (
                      <div className='productItem_bottom_flag' ></div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default IndexPage;